export const QUESTIONS = [
   { formName: 'teachersCommit', _id: 0, q: '¿Cómo calificarías tu experiencia con los docentes?' },
   { formName: 'moderation', _id: 1, q: '¿Cómo calificarías tu experiencia con la moderación académica?' },
   { formName: 'forVetExperience', _id: 3, q: '¿Cómo calificarías tu experiencia con la institución?' },
   { formName: 'webCampusValue', _id: 4, q: '¿Cómo calificarías tu experiencia con nuestra web y campus virtual?' },
]